var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showReanalysisAlert && _vm.price !== null)?_c('v-alert',{staticStyle:{"grid-area":"price"},attrs:{"icon":"mdi-cash-usd-outline","text":"","type":'info',"outlined":""}},[_c('span',[_vm._v("Price: $"+_vm._s(_vm.price)+" AUD "+_vm._s(_vm.medicare ? "(Provided by Medicare)" : "")+" "),_vm._t("funding")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }